module.exports = __webpack_public_path__ + "img/W7028-full.f12a53d2.jpg";